export default function SectionHead({ title, sub, actions }) {
  return (
    <div className="sec-head">
      <div>
        <h2>{title}</h2>
        {sub && <p>{sub}</p>}
      </div>
      {actions && <div className="actions">{actions}</div>}
    </div>
  );
}
